import { CssBaseline } from '@material-ui/core'
import { SnackbarProvider } from 'notistack'
import React from 'react'

import { ErrorContainer } from './atoms/ErrorContainer'
import { LogRoute } from './routes/LogRoute'
import { Routing } from './routes/Routing'

export const App: React.FC = () => (
  <ErrorContainer prod={process.env.NODE_ENV === 'production'}>
    <CssBaseline />
    <LogRoute />
    <SnackbarProvider maxSnack={3}>
      <Routing />
    </SnackbarProvider>
  </ErrorContainer>
)
